import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConstruction,
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const propertyOwnerShortTermAccommodationRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    price: validationRules.price,
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    buildingType: validationRules.buildingType,
    startRentalDate: validationRules.startRentalDateRequired,
    additionalCosts: validationRules.additionalCosts,
    deposit: validationRules.deposit,
  },
  description: {
    ...defaultDescription,
    adFurnishingNote: validationRules.adFurnishingNote,
  },
  otherFacilities: {
    minRentalTime: validationRules.minRentalTime,
    maxRentalTime: validationRules.maxRentalTime,
    maxNumberOfPersons: validationRules.maxNumberOfPersons,
    floor: validationRules.floor,
    totalFloorsNumber: validationRules.totalFloorsWithDependingFloorNumber,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  construction: defaultConstruction,
  contactInfo: defaultContactInfo,
}
